import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Reveal from '../components/Reveal';
import { licensedStatesShort, pendingLicenseNote } from '../constants/marketExpansion';

export default function DoorlyProLanding() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!document.querySelector('link[href*="calendly"]')) {
      const link = document.createElement('link');
      link.href = 'https://assets.calendly.com/assets/external/widget.css';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    if (!document.querySelector('script[src*="calendly"]')) {
      const s = document.createElement('script');
      s.src = 'https://assets.calendly.com/assets/external/widget.js';
      s.async = true;
      document.head.appendChild(s);
    }
  }, []);

  const openDiscoveryCall = (e) => {
    e.preventDefault();
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: 'https://calendly.com/jesse-coody/doorly-discovery' });
    } else {
      window.open('https://calendly.com/jesse-coody/doorly-discovery', '_blank');
    }
  };

  useEffect(() => {
    const prev = document.title;
    // ── 🚨 "Faster" WAS A TURNAROUND CLAIM, IN THE PAGE TITLE ──────────────
    //
    // Zero Doorly loans have consummated — no note signed, no deed of trust, no
    // funding row — so there is no observed closing time or approval time behind
    // the word, and this is the string search engines and link previews carry.
    // The same claim was stripped from the partner drip; leaving it on the page
    // the drip links TO would have been the drift, not a smaller version of it.
    //
    // 🔑 THE STRUCTURAL CLAIM REPLACES IT. Doorly is the cash buyer, so the
    // offer carries no financing contingency. True today, stronger for this
    // audience, and it needs no closing history.
    document.title = 'DoorlyPro — Cash Offers for Buyers Who Cannot Qualify Yet';
    const og = document.querySelector('meta[property="og:title"]');
    const tw = document.querySelector('meta[name="twitter:title"]');
    if (og) og.setAttribute('content', 'DoorlyPro — Cash Offers for Buyers Who Cannot Qualify Yet');
    if (tw) tw.setAttribute('content', 'DoorlyPro — Cash Offers for Buyers Who Cannot Qualify Yet');
    return () => {
      document.title = prev;
      if (og) og.setAttribute('content', 'Doorly Mortgage – Get Pre-Qualified in Minutes');
      if (tw) tw.setAttribute('content', 'Doorly Mortgage – Get Pre-Qualified in Minutes');
    };
  }, []);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <div className="min-h-screen flex flex-col bg-white">

      {/* ── NAV ── */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between" style={{ height: '4.5rem' }}>
            <a href="https://www.godoorly.com" className="flex items-center">
              <img
                src="/assets/DoorlyPro.png"
                alt="DoorlyPro"
                style={{ height: '32px', width: 'auto', objectFit: 'contain', display: 'block' }}
              />
            </a>

            {/* Desktop nav — hidden on mobile, replaced by hamburger below */}
            <div className="hidden sm:flex items-center gap-2">
              <Link
                to="/"
                className="px-4 py-2 rounded-full text-sm font-medium text-black hover:text-doorly-blue hover:bg-gray-100 transition-colors duration-200"
              >
                Home
              </Link>
              <Link
                to="/doorlypro/login"
                className="px-4 py-1.5 rounded-full text-sm font-semibold text-black border border-gray-200 hover:bg-gray-50 transition-colors"
              >
                Log In
              </Link>
              <Link
                to="/doorlypro/start"
                className="px-4 py-1.5 rounded-full text-sm font-bold transition-colors"
                style={{ backgroundColor: '#fffd5b', color: '#000' }}
              >
                Join Now
              </Link>
            </div>

            {/* Mobile hamburger — only visible below sm */}
            <button
              type="button"
              onClick={() => setMobileMenuOpen((o) => !o)}
              aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={mobileMenuOpen}
              className="sm:hidden p-2 -mr-2 rounded-md text-black hover:bg-gray-100 transition-colors"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {mobileMenuOpen ? (
                  <>
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </>
                ) : (
                  <>
                    <line x1="3" y1="6" x2="21" y2="6" />
                    <line x1="3" y1="12" x2="21" y2="12" />
                    <line x1="3" y1="18" x2="21" y2="18" />
                  </>
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile dropdown panel */}
        {mobileMenuOpen && (
          <div className="sm:hidden border-t border-gray-100 bg-white shadow-sm">
            <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-2">
              <Link
                to="/"
                onClick={closeMobileMenu}
                className="block px-4 py-2.5 rounded-md text-sm font-semibold text-black hover:bg-gray-100 transition-colors text-center"
              >
                Home
              </Link>
              <Link
                to="/doorlypro/login"
                onClick={closeMobileMenu}
                className="block px-4 py-2.5 rounded-md text-sm font-semibold text-black border border-gray-200 hover:bg-gray-50 transition-colors text-center"
              >
                Log In
              </Link>
              <Link
                to="/doorlypro/start"
                onClick={closeMobileMenu}
                className="block px-4 py-2.5 rounded-md text-sm font-bold transition-colors text-center"
                style={{ backgroundColor: '#fffd5b', color: '#000' }}
              >
                Join Now
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* ── HERO ── */}
      <section
        className="pt-28 sm:pt-36 pb-20 px-4 sm:px-6 lg:px-8"
        style={{ background: '#3a6ad9' }}
      >
        <div className="max-w-3xl mx-auto text-center">
          <Reveal>
            <div
              className="inline-flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-full mb-6 uppercase tracking-wider"
              style={{
                backgroundColor: 'rgba(255,255,255,0.12)',
                border: '1px solid rgba(255,255,255,0.25)',
                color: '#ffffff',
              }}
            >
              <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: '#ffffff' }} />
              For Licensed Professionals
            </div>
          </Reveal>

          <Reveal delay={80}>
            {/* Mobile gets text-3xl + tracking-tight so the explicit
                "Turn More Buyers" / "Into Closed Deals" line break doesn't
                cause line-2 to wrap onto a third line at iPhone widths.
                Scales up from sm: as before. */}
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight mb-6 text-white">
              Turn More Buyers<br />
              <span style={{ color: '#fffd5b' }}>Into Closed Deals</span>
            </h1>
          </Reveal>

          <Reveal delay={160}>
            <p className="text-lg sm:text-xl leading-relaxed mb-10 max-w-2xl mx-auto" style={{ color: 'rgba(255,255,255,0.75)' }}>
              Send your clients through Doorly and give them a path that does not depend on a lender approving them after the offer. Doorly is the cash buyer, so the offer carries no financing contingency. When they close, you earn. No cost to join and no minimums.
            </p>
          </Reveal>

          <Reveal delay={240}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/doorlypro/start"
                className="doorly-cta doorly-cta-yellow text-base px-6 py-3 w-full sm:w-auto justify-center"
              >
                <span className="doorly-cta-text">Become a DoorlyPro Partner</span>
                <span className="doorly-cta-badge" aria-hidden="true">→</span>
              </Link>
              <Link
                to="/doorlypro/login"
                className="doorly-cta text-base px-6 py-3 w-full sm:w-auto justify-center"
                style={{ backgroundColor: 'transparent', color: '#fff', border: '2px solid rgba(255,255,255,0.4)' }}
              >
                <span className="doorly-cta-text">Partner Login</span>
                <span className="doorly-cta-badge" aria-hidden="true" style={{ backgroundColor: 'rgba(255,255,255,0.2)', color: '#fff' }}>→</span>
              </Link>
            </div>
          </Reveal>

          <Reveal delay={320}>
            <p className="text-xs mt-6 flex flex-wrap justify-center gap-x-4 gap-y-1" style={{ color: 'rgba(255,255,255,0.4)' }}>
              {/* ⚠️ "Texas & Florida" WAS THE SECOND FLORIDA CLAIM ON THIS PAGE.
                  The stat card was fixed in the previous commit and this badge
                  was not — the licence check looked for "TX + FL", "Texas and
                  Florida" and "Texas + Florida", and an ampersand walked
                  through it. Derived now, so no spelling can survive the
                  licence changing. */}
              {['Free to join', 'Licensed mortgage and real estate professionals only', `Licensed in ${licensedStatesShort()}`].map(text => (
                <span key={text} className="flex items-center gap-1">
                  <svg className="w-3 h-3 flex-shrink-0" style={{ color: '#acf44e' }} fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  {text}
                </span>
              ))}
            </p>
          </Reveal>
        </div>
      </section>

      {/* ── DISCOVERY CALL ── */}
      <section style={{ background: '#f4f6f9', padding: '64px 24px', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>
        <Reveal>
        <div style={{ maxWidth: '560px', margin: '0 auto' }}>
          <div style={{ display: 'inline-block', fontSize: '11px', fontWeight: '700', color: '#3a6ad9', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '14px', padding: '4px 14px', background: '#edf1fb', borderRadius: '20px', border: '1px solid #c5d3f5' }}>
            For Realtors, LOs & Homebuilders
          </div>
          <h2 style={{ margin: '0 0 16px', fontSize: '32px', fontWeight: '800', color: '#111827', lineHeight: '1.25', letterSpacing: '-0.5px' }}>
            Interested in becoming a Doorly partner?
          </h2>
          <p style={{ margin: '0 0 32px', fontSize: '17px', color: '#6b7280', lineHeight: '1.75' }}>
            Jump on a quick call with our team. We'll walk you through the program, answer your questions, and get you set up — usually in under 30 minutes.
          </p>
          <button onClick={openDiscoveryCall}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '15px 36px', background: '#3a6ad9', color: '#ffffff', border: 'none', borderRadius: '12px', cursor: 'pointer', fontSize: '16px', fontWeight: '800', letterSpacing: '-0.2px', transition: 'background 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.background = '#2d5bc4'}
            onMouseLeave={e => e.currentTarget.style.background = '#3a6ad9'}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            Schedule a Discovery Call
          </button>
          <p style={{ margin: '16px 0 0', fontSize: '13px', color: '#9ca3af' }}>Free · No commitment · 30 minutes</p>
        </div>
        </Reveal>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="bg-white py-20 px-4 sm:px-6 lg:px-8 border-t border-gray-100">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <div className="text-center mb-14">
              <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4">How DoorlyPro Works</h2>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                Three simple steps from submission to closing
              </p>
            </div>
          </Reveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-gradient-to-r from-doorly-blue/20 via-doorly-blue to-doorly-blue/20 z-0" />
            {[
              {
                number: '01',
                title: 'Submit a Buyer',
                description: 'Submit your client in under 2 minutes through the DoorlyPro dashboard. Just enter their basic info and they will be invited to apply.',
                color: '#3a6ad9',
                icon: (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                ),
              },
              {
                number: '02',
                title: 'Doorly Takes It From There',
                description: 'We guide your client from application to keys—handling approval, home search, offer submission, and closing. Because Doorly is the purchaser, the offer goes in without a financing contingency.',
                color: '#000000',
                icon: (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                ),
              },
              {
                number: '03',
                title: 'You Get Paid',
                // ⚠️ "processed quickly" WAS THE PAYMENT SCHEDULE WEARING AN
                // ADVERB. Earned is not paid: the earning trigger may be stated,
                // the timing may not — and "quickly" is a timing claim with
                // nothing behind it, since no partner fee has been processed at
                // all. What IS true is the visibility, which is the part a
                // partner actually asked for.
                description: 'Track your buyer from application to closing. When your buyer closes, you earn a partner fee—visible on your dashboard as it is generated. No caps. No chasing updates.',
                color: '#3a6ad9',
                icon: (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                ),
              },
            ].map((step, index) => (
              <Reveal key={index} delay={index * 100}>
                <div className="relative z-10 bg-white rounded-2xl p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-center group border border-gray-100 h-full">
                  <div
                    className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-5 transition-colors duration-300"
                    style={{ backgroundColor: '#fffd5b' }}
                  >
                    <div style={{ color: '#000' }}>{step.icon}</div>
                  </div>
                  <div className="font-extrabold text-6xl absolute top-4 right-6 select-none" style={{ color: step.color + '12' }}>
                    {step.number}
                  </div>
                  <h3 className="text-xl font-bold text-black mb-3">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY DOORLYPRO ── */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 border-t border-gray-100" style={{ backgroundColor: '#f9fafb' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <Reveal>
                <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4 leading-tight">
                  Stop Losing Buyers Who{' '}
                  <span style={{ color: '#3a6ad9' }}>Don't Qualify Yet</span>
                </h2>
                <p className="text-gray-600 text-lg leading-relaxed mb-8">
                  Most agents walk away from buyers who can't qualify today. DoorlyPro lets you keep that relationship—and earn from it.
                </p>
              </Reveal>
              <div className="space-y-3">
                {/* ── 🚨 TWO OF THESE FIVE MADE CLAIMS DOORLY CANNOT BACK ──────
                    · "Build a recurring revenue stream from leads you already
                      have" — an income claim. Zero closings, so no partner has
                      earned anything and nothing establishes that a stream
                      exists, let alone a recurring one.
                    · "Earn fees on closings you would have otherwise lost"
                      asserts the counterfactual as fact. Reworded to the
                      earning TRIGGER, which is a term of the deal and may be
                      stated — see docs/borrower-copy-rules.md, "earned is not
                      paid".

                    🔑 THE REPLACEMENTS ARE WHAT REGISTERING ACTUALLY GIVES THEM.
                    The matrices and the eligibility tool are the two things a
                    partner cannot see from outside, they are what the drip
                    promises on day one, and until now no public surface said so.
                    Structural, checkable, and true before any file closes. */}
                {[
                  'Earn partner compensation on a successful closing',
                  'The full eligibility matrices — FICO, LTV, DTI and reserves by loan size',
                  'An eligibility tool that tells you whether a buyer fits before you invest a weekend',
                  'No transaction coordinator work — we handle everything',
                  'Real-time status updates on every referral in your dashboard',
                  'Keep the relationship with a buyer you would otherwise hand back',
                ].map((item, i) => (
                  <Reveal key={i} delay={120 + i * 60} y={10}>
                    <div className="flex items-start gap-3">
                      <div
                        className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                        style={{ backgroundColor: '#acf44e' }}
                      >
                        <svg className="w-3 h-3" fill="none" stroke="#000" strokeWidth="3" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>

            {/* Stat cards */}
            <div className="space-y-4">
              {/* ── 🚨 THREE OF THE FOUR CARDS HERE WERE NOT TRUE ────────────
                  · "Average days to close — ~20 days". ZERO Doorly loans have
                    consummated: no note signed, no deed of trust, no funding
                    row. That was a statistic presented as observed fact with
                    nothing behind it, on the page that recruits partners, who
                    would repeat it to a listing agent to win an offer.
                  · "Markets served — TX + FL". Doorly holds a Texas license;
                    Florida is PENDING, and taking the application is itself the
                    licensed activity under Fla. Stat. Ch. 494. The same defect
                    the partner drip had — see backend/constants/marketExpansion
                    — now reading from a mirrored constant instead of a literal.
                  · "Partner fee paid within — 30 days". This is the banned cell
                    in docs/borrower-copy-rules.md, verbatim. Earned is not paid:
                    the earning trigger is a term of the deal and may be stated,
                    the payment schedule is timing and may not. The rule was
                    written because the DRIP said it; the landing page had been
                    saying it too.

                  🔑 THE REPLACEMENTS ARE STRUCTURAL. Each is true today, needs
                  no closing history, and cannot go stale. The financing
                  contingency card is the honest version of the speed claim:
                  Doorly is the cash buyer, so the offer does not depend on a
                  lender approving the buyer afterwards. */}
              {[
                { label: 'Ability-First Mortgage', value: 'Our Program', color: '#3a6ad9', bg: '#eff4ff', border: '#bfcff8' },
                { label: 'Financing contingency', value: 'None', color: '#000', bg: '#f3f4f6', border: '#e5e7eb' },
                { label: 'Licensed to lend in', value: licensedStatesShort(), color: '#3a6ad9', bg: '#eff4ff', border: '#bfcff8' },
                { label: 'Partner fee earned', value: 'On a closing', color: '#000', bg: '#f3f4f6', border: '#e5e7eb' },
              ].map((stat, i) => (
                <Reveal key={i} delay={i * 90} y={12}>
                  <div
                    className="rounded-2xl p-5 flex justify-between items-center transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
                    style={{ backgroundColor: stat.bg, border: `1px solid ${stat.border}` }}
                  >
                    <span className="text-gray-600 text-sm font-medium">{stat.label}</span>
                    <span className="text-xl font-bold" style={{ color: stat.color }}>{stat.value}</span>
                  </div>
                </Reveal>
              ))}
              {/* ⚠️ THE PENDING STATE IS NAMED, NOT SILENTLY DROPPED. A partner
                  who works Florida deals learns nothing from a list that simply
                  lacks it — "in progress" is the answer they need, and the
                  helper renders to '' the day the license issues. */}
              {pendingLicenseNote() && (
                <p className="text-xs text-gray-400 text-center pt-1">{pendingLicenseNote()}</p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ── WHO TO REFER ── */}
      <section className="bg-white py-20 px-4 sm:px-6 lg:px-8 border-t border-gray-100">
        <div className="max-w-4xl mx-auto text-center">
          <Reveal>
            <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4">Who to Submit</h2>
            <p className="text-gray-600 text-lg max-w-xl mx-auto mb-12">
              Doorly is built for buyers who are motivated but don't fit the traditional lending box
            </p>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left max-w-3xl mx-auto">
            {[
              { text: 'Stable income — including self-employed or non-traditional', good: true },
              { text: 'Has funds for down payment and closing costs', good: true },
              { text: 'Motivated to buy in the near term', good: true },
              { text: 'Open to a streamlined, digital process', good: true },
              { text: 'No verifiable income source', good: false },
              { text: 'Active bankruptcy or unresolved major credit issues', good: false },
              { text: 'Insufficient funds to close', good: false },
              { text: 'Non-owner-occupied / investment intent', good: false },
            ].map((item, i) => (
              <Reveal key={i} delay={i * 60} y={10}>
                <div
                  className="flex items-start gap-3 rounded-xl p-4 bg-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
                  style={{ border: `1px solid ${item.good ? '#acf44e' : '#ff082f'}` }}
                >
                  <div
                    className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                    style={{
                      backgroundColor: item.good ? '#acf44e' : '#ff082f',
                      color: item.good ? '#000' : '#fff',
                    }}
                  >
                    <span className="text-xs font-bold">{item.good ? '✓' : '✗'}</span>
                  </div>
                  <span className="text-gray-700 text-sm leading-relaxed">{item.text}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section
        className="py-20 px-4 sm:px-6 lg:px-8 text-center"
        style={{ background: '#3a6ad9' }}
      >
        <div className="max-w-2xl mx-auto">
          <Reveal>
            <div style={{ width: '48px', height: '4px', background: '#fffd5b', borderRadius: '2px', margin: '0 auto 24px' }} />
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 leading-tight">
              Ready to Start Earning?
            </h2>
            <p className="text-lg leading-relaxed mb-10" style={{ color: 'rgba(255,255,255,0.7)' }}>
              Join licensed agents already earning partner fees with DoorlyPro. Takes less than 5 minutes.
            </p>
          </Reveal>
          <Reveal delay={150}>
            <Link
              to="/doorlypro/start"
              className="doorly-cta doorly-cta-yellow text-base px-6 py-3 inline-flex"
            >
              <span className="doorly-cta-text">Create Your Free Account</span>
              <span className="doorly-cta-badge" aria-hidden="true">→</span>
            </Link>
            <p className="text-xs mt-6" style={{ color: 'rgba(255,255,255,0.35)' }}>
              Licensed mortgage and real estate professionals only · Free to join · No minimum referrals
            </p>
          </Reveal>
        </div>
      </section>

      {/* ── FOOTER — partner-facing links ── */}
      <footer className="px-5 sm:px-10 py-6 sm:py-7" style={{
        background: '#3a6ad9',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        borderTop: '1px solid rgba(255,255,255,0.08)',
      }}>
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.35)' }}>
          Go Doorly, LLC | NMLS #2764749 | Equal Housing Opportunity
        </div>
        <div className="flex flex-wrap gap-x-5 gap-y-2 sm:gap-x-6">
          {[
            { label: 'Partner Login', path: '/doorlypro/login' },
            { label: 'Register', path: '/doorlypro/start' },
            { label: 'Partner Dashboard', path: '/doorlypro/dashboard' },
            { label: 'Submit a Referral', path: '/doorlypro/referrals' },
            { label: 'My Earnings', path: '/doorlypro/compensation' },
            { label: 'Support', path: 'mailto:support@godoorly.com' },
          ].map(link => (
            <span
              key={link.label}
              onClick={() => link.path.startsWith('mailto') ? (window.location.href = link.path) : navigate(link.path)}
              style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', transition: 'color 0.15s' }}
              onMouseEnter={e => e.target.style.color = '#fffd5b'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
            >
              {link.label}
            </span>
          ))}
        </div>
        </div>
      </footer>
    </div>
  );
}
